<template>
  <div class="app">
    <div class="app">
      <img src="@/assets/background.png" class="background" />
      <div class="content-box">
        <div class="content-left">
          <div class="text1">Enter the email and user name you filled in the APP</div>
          <div class="text2">we will verify and delete the user information within 7 working days</div>
        </div>
        <div class="content-right">
          <el-input
            v-model="email"
            placeholder="please enter your email"
            style="width: 324px; margin-top: 24px; height: 48px"
          ></el-input>

          <el-input
            v-model="nickname"
            placeholder="please enter your nickname"
            style="width: 324px; height: 48px"
          ></el-input>
          <div
            style="
              width: 100%;
              justify-content: center;
              display: flex;
              height: 40px;
            "
          >
            <el-button @click="submit()">Submit</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "app",
  data: function () {
    return {
      email: '',
      nickname: '',
    };
  },
  mounted() {

  },

  methods: {
    async submit() {
      if (this.email === '') {
        this.$message.warning('Please enter your email')
      } else if (this.nickname === '') {
        this.$message.warning('Please enter your nickname')
      }
      let res = await this.axios.post('https://api.loopsports.cn/userIntl/wx_userCancel', {
        uid: 1,
        token: '1',
        email: this.email,
        nickname: this.nickname,
      });
      console.log(res);
      if (res.data.code === 1) {
        this.$message.success('Success');
        this.email = '';
        this.nickname = '';
      } else {
        this.$message.warning(res.data.msg)
      }
    },
  },
};
</script>

<style scoped>
.mobileApp {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
}
html,
body,
#app,
.app .mobileApp {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  position: relative;
}

#app,
.app {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.content-box {
  width: 1020px;
  height: 55%;
  background-color: #ffffff;
  border-radius: 24px;
  display: flex;
}

.content-left {
  width: 440px;
  height: 100%;
  background-image: linear-gradient(
    0deg,
    #dedede 0%,
    #efeb7b 44%,
    #fff717 100%
  );
  border-radius: 24px 0px 0px 24px;
  padding-left: 36px;
}

.text1 {
  padding-top: 48px;
  font-size: 36px;
  color: #5e5e5e;
}

.text2 {
  margin-top: 12px;
  font-size: 24px;
  color: #5e5e5e;
}

.content-right {
  width: 540px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-content: flex-start;
}

.text3 {
  width: 100%;
  font-size: 24px;
  color: #666666;
  padding: 48px 0 0 36px;
}
.el-table th>.cell{
  padding-left: 20px;
}
.el-table .cell{
  padding-left: 20px;
}
.el-table .el-table_1_column_2 .cell{
  padding-right: 16px;
  padding-left: 0;
  text-align: left;
}
.el-button--mini, .el-button--small{
  font-size: 14px;
}
</style>
